<template>
  <div class="messageBox">
    <el-input
      resize="none"
      rows="3"
      type="textarea"
      v-model="content"
      :placeholder="placeholder"
      ref="textareaRef"
      maxlength="100"
    >
    </el-input>
    <div class="btnBox">
      <div class="btnBox_left target" v-if="targetName" @click="clearTarget">
        <div>{{ targetName }}</div>
        <i class="el-icon-close"></i>
      </div>
      <div class="btnBox_left pointer" v-else @click="onFocus">
        <i class="el-icon-edit"></i>
        <div>写评论</div>
      </div>
      <div>
        <span style="color: #999999;margin-right: 16px;font-size: 12px;">{{ content.length }}/100</span>
        <el-button
          type="primary"
          class="btn"
          size="mini"
          style="width: 50px; height: 30px"
          @click="onSend"
          >发送</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapState("information", ["messageFrom", "targetData", "detailData"]),
    content: {
      get() {
        return this.messageFrom.content;
      },
      set(content) {
        this.setMessageFrom({ content });
      },
    },
    targetName() {
      if (this.targetData.empName) {
        return this.targetData.empName;
      }
      return "";
    },
    placeholder() {
      if (this.targetName) {
        return `回复 ${this.targetName}`;
      }
      return `评论 ${this.detailData.authorName}`;
    },
  },
  methods: {
    ...mapMutations("information", ["setMessageFrom"]),
    ...mapActions("information", ["postMessageComment", "clearTarget"]),
    async onSend() {
      const { status, data: message } = await this.postMessageComment();
      if (status === 200) {
        this.$message.success(message);
        this.setMessageFrom({ content: "" });
      } else {
        this.$message.error(message);
      }
    },
    onFocus() {
      this.$refs.textareaRef.focus();
    },
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
.messageBox {
  height: $messageBoxHeight;
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 16px 30px;
  background: #fff;
  .btnBox {
    display: flex;
    justify-content: space-between;
    height: 30px;
    margin-top: 8px;
    align-items: center;
    &_left {
      display: flex;
      gap: 2px;
      color: #999999;
      font-size: 14px;
      line-height: normal;
      letter-spacing: 0px;
      align-items: center;
      &:hover {
        color: #0062ff;
      }
    }
    .target {
      width: auto;
      padding: 0 6px;
      height: 18px;
      border-radius: 4px;
      display: flex;
      border: 1px solid #eeeeee;
      align-items: center;
      justify-content: center;

      font-size: 10px;
      line-height: 10px;
      letter-spacing: 0em;
      color: #999999;
      cursor: pointer;
      &:hover {
        color: #999999;
        i {
          color: #0062ff;
        }
      }
    }
  }
}
</style>
